import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Comments } from "./Comments";
import { Context } from "../context";
import { getDataById } from "./utils";
import { Metadata } from "./Metadata";
import { MetadataAdd } from './MetadataAdd';
import { PlayerYoutube } from './PlayerYoutube';
import { VideoJS } from './PlayerVideo';

import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';



export function PlayerInner({ history, match, location }) {
  console.log("match = ", match);
  const context = useContext(Context);

  const [expanded, setExpanded] = useState(false);


  const [videoId, setVideoId] = useState("");
  useEffect(() => {
    if (match.params["videoId"] !== videoId) {
      setVideoId(match.params["videoId"]);
    }
  }, [match]);


  const [duration, setDuration] = useState(0);


  const getInfo = (d) => setDuration(d);


  const videoUrl = `https://www.youtube.com/embed/${getDataById(
    context,
    "videos",
    match["params"]["videoId"],
    "url"
  )}`

  const mp4 = getDataById(
    context,
    "videos",
    match["params"]["videoId"],
    "mp4"
    );
    console.log('mp4 = ', mp4);

  return (
    <div
      // className={`l_video ${expanded ? "l_video--md" : "l_video--sm"}`}
      className={`l_video`}
    >
      <div className="h0">
        <div
          className="ui_tabs"
          // className="ui_tabs ui_tabs--expandable"
          // onClick={() => setExpanded(!expanded)}
        >
          <div className="ui_tabs__ul">
            <div className="ui_tabs__li">
              <div className="ui_tabs__menu_item ui_tabs__menu_item--header">
                <div>Player</div>
                {/* <div className="m_ico m_ico--rotate">
                  {!expanded && <div>unfold_more</div>}
                  {expanded && <div>unfold_less</div>}
                </div> */}
              </div>
            </div>
            <div className="ui_tabs__li ui_tabs__li--right"></div>
          </div>
        </div>
      </div>

      {/* {getDataById(context, 'videos', match.params['videoId'], 'url')} */}

      <div className="l_video_player">
        <div className="p_p_embed w-embed w-iframe">


          {videoUrl && !mp4 && <PlayerYoutube
            videoUrl={videoUrl}
          />}

          {mp4 && <VideoJS
            getInfo={getInfo}
            setTime
            video={mp4}
          />}

          {/* {duration} */}
          {/* {videoInfo['currentTime']} */}

        </div>
      </div>

      <div className="l_video_metadata0">
        {/* <div className="l_video_meta_scroll0"> */}
        <PerfectScrollbar>
          <div className="l_video_meta_scroll">
            <Metadata videoId={match["params"]["videoId"]} />
          </div>
          </PerfectScrollbar>
        {/* </div> */}
      </div>

    </div>
  );
}

export const Player = withRouter(PlayerInner);
